import Axios, { AxiosError, AxiosResponse } from 'axios';
import { Url } from '../general/modules/url';
import * as querystring from 'query-string';
import { getUserSuid } from '../general/modules/getUserSuid';
import { HTTP_STATUS_FORBIDDEN } from '../constants/http';
import { ApiRequestError } from './ApiRequestError';
import { container } from '../utils/container/container';
import { GlobalAppConfig } from '../types/windowPatching';
import { ServiceIds } from '../utils/container/service-ids';

type ApiQueryParams = { [key: string]: string };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ApiRequestData = { [key: string]: any };

export class Api {
    public static async post(
        action: string,
        queryParams: ApiQueryParams = {},
        data: ApiRequestData = {}
    ): Promise<AxiosResponse> {
        let url: string;
        let enrichedData = { ...data };

        url = Url.getNoLangUrl(`api/${action}`);

        if (Object.values(queryParams).length) {
            url = `${url}?${querystring.stringify(queryParams)}`;
        }

        const config = container.get<GlobalAppConfig>(ServiceIds.CONFIG);
        if (typeof getUserSuid !== 'undefined' && typeof config.sig !== 'undefined') {
            enrichedData = {
                ...enrichedData,
                suid: getUserSuid(),
                sig: config.sig
            };
        }

        return Axios.post(url, querystring.stringify(enrichedData, { arrayFormat: 'index' }))
            .catch((error: AxiosError) => {
                if (error?.response?.status === HTTP_STATUS_FORBIDDEN) {
                    location.reload();
                }

                throw new ApiRequestError(error.message, error);
            });
    }
}
